<template>
  <div v-if="permissionDetail">
    <topsearch :title="permissionDetail.name + ' #' + id" />

    <div class="content-section flex flex-col md:flex-row">
      <form
        style="width: 800px"
        @submit="formSubmit()"
        action="javascript:void(0)"
        method="post"
      >
        <template v-for="item in resp.fields">
          <div class="edit-form-item">
            <form-item
              :label="true"
              :form="editForm"
              :input="fieldsMap[item]"
              :value="editForm[item]"
              v-if="fieldsMap[item]"
              @changed="gelen => editFormSet(gelen)"
              :type="fieldsMap[item].component.name"
            />
          </div>
        </template>
        <savebutton v-if="resp.fields" action="formSubmit" />
      </form>
    </div>
  </div>
</template>

<script>
import httpService from "../services/http";
import FormItemVue from "../components/Ui/FormItem.vue";
import EventBus from "../components/Ui/EventBus";
export default {
  components: {
    "form-item": FormItemVue
  },
  data() {
    return {
      resp: {},
      editForm: [],
      loading: false,
      fieldsMap: {},
      messages: []
    };
  },
  computed: {
    permissionDetail() {
      if (this.$root.cache.permissions == false) {
        this.$axios
          .get(this.$root.config.endpoint + "/permissions")
          .then(response => {
            this.$root.cache.permissions = response.data.tables;
            return this.$root.cache.permissions.find(
              e => e.table == this.table
            );
          });
      } else {
        return this.$root.cache.permissions.find(e => e.table == this.table);
      }
    }
  },
  methods: {
    formSubmit() {
      this.loading = true;

      EventBus.$emit("loadingStatus", {
        action: "formSubmit",
        loading: true
      });

      httpService
        .detailSave({
          table: this.$route.params.table,
          id: this.$route.params.id,
          inputs: this.editForm
        })
        .then(response => {
          if (response.data.success == true) {
            this.$root.successMessage("İşlem başarıyla kaydedildi");
            EventBus.$emit("loadingStatus", {
              action: "formSubmit",
              loading: false,
              success: true
            });
          } else {
            this.$root.errorMessage(
              "İşlem başarısız, yaptığınız işlemi tekrar kontrol ediniz"
            );
            EventBus.$emit("loadingStatus", {
              action: "formSubmit",
              loading: false,
              success: false
            });
          }
        })
        .catch(() => {
          this.$root.errorMessage(
            "İşlem başarısız, yaptığınız işlemi tekrar kontrol ediniz"
          );
          EventBus.$emit("loadingStatus", {
            action: "formSubmit",
            loading: false,
            success: false
          });
        })
        .finally(e => {
          this.loading = false;
        });
    },
    editFormSet(val) {
      this.editForm[val.name] = val.value;
    }
  },
  created() {
    this.table = this.$route.params.table;
    this.id = this.$route.params.id;
    httpService.fields(this.table).then(resp => {
      this.fields = resp.data;

      this.fields.map(field => {
        this.fieldsMap[field.name] = field;
      });

      httpService
        .getDetail(this.$route.params.table, this.$route.params.id)
        .then(resp => {
          this.resp = resp.data;
          this.editForm = this.resp.results;
        });
    });
  }
};
</script>

<style scoped>
.edit-form-item {
  margin-bottom: 10px;
}
</style>
